import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'How much does a patio installation cost in Glen Mills?',
      answer: 'Patio installation costs typically range from $15,000 to $45,000 depending on size, materials, and complexity. A standard 300 sq ft paver patio averages $20,000-$25,000. We provide detailed, transparent estimates after assessing your specific project requirements.'
    },
    {
      question: "What's the best time of year for landscaping projects?",
      answer: 'Spring (April-May) and fall (September-October) are ideal for most landscaping projects in Pennsylvania. However, hardscaping projects like patios and retaining walls can be completed year-round. We recommend booking 2-3 months in advance for peak season projects.'
    },
    {
      question: 'Do you offer financing for large projects?',
      answer: 'Yes, we partner with leading financing providers to offer flexible payment plans for projects over $10,000. Options include 0% interest for qualified buyers and extended payment terms. Our team can discuss financing options during your consultation.'
    },
    {
      question: 'How long does a typical hardscape project take?',
      answer: 'Most patio installations take 5-10 days from start to finish. Larger projects with retaining walls or outdoor kitchens may take 2-4 weeks. Timeline depends on project scope, weather, and material availability. We provide a detailed schedule in your proposal.'
    },
    {
      question: "What's included in your landscape design service?",
      answer: 'Our design service includes an on-site consultation, detailed measurements, 3D renderings, plant selection, material specifications, and a comprehensive installation plan. Design fees are typically credited toward your project if you proceed with installation.'
    },
    {
      question: 'Do you provide maintenance after installation?',
      answer: 'Yes, we offer comprehensive maintenance programs including seasonal cleanups, lawn care, pruning, mulching, and hardscape cleaning. Many clients choose our maintenance services to protect their investment and keep their outdoor spaces looking pristine year-round.'
    }
  ];

  return (
    <section className="py-24 bg-[#F5F5F5]">
      <div className="max-w-[1200px] mx-auto px-6">
        <div className="text-center mb-16">
          <div className="text-[#E67E22] text-xs font-semibold tracking-[0.2em] uppercase mb-4">
            FREQUENTLY ASKED QUESTIONS
          </div>
          <h2 className="text-5xl font-bold text-gray-900">Everything You Need to Know</h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-2xl border border-gray-200 overflow-hidden">
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 flex items-start justify-between gap-4 text-left hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <span className="text-lg font-bold text-gray-900 flex-1">{faq.question}</span>
                <i className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-2xl text-[#E67E22] flex-shrink-0 transition-transform`}></i>
              </button>
              {openIndex === index && (
                <div className="px-8 pb-6">
                  <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}